import {Pipe, PipeTransform} from '@angular/core';
import {WeekdayInterval} from '../../supervision-management/compliance-items/compliance-item/enums/weekday-interval.enum';
@Pipe({
    name: 'weekdayIntervalDisplay',
    pure: false
})
export class WeekdayIntervalDisplayPipe implements PipeTransform {
    constructor() {}

    transform(weekdayInterval: any): string {
        let retval: string = '';

        switch (Number(weekdayInterval)) {
            case WeekdayInterval.FIRST:
                retval = 'first';
                break;

            case WeekdayInterval.SECOND:
                retval = 'second';
                break;

            case WeekdayInterval.THIRD:
                retval = 'third';
                break;

            case WeekdayInterval.FOURTH:
                retval = 'fourth';
                break;

            case WeekdayInterval.FIFTH:
                retval = 'fifth';
                break;
        }

        return retval;
    }
}